<template>
  <section class="overview">
    <div class="max-w-6xl mx-auto px-4 py-12">
      <div class="container text-center mb-12">
        <h2 class="text-3xl font-bold italic bg-[#FFE54F4D] inline-block px-8 py-2">Quick Program Overview</h2>
      </div>

      <div class="grid md:grid-cols-4 gap-8 items-center mb-12">
          <!-- Icon 1: Free Trial -->
          <div class="flex flex-col items-center">
            <div class="rounded-full border border-[#FFE54F] w-[140px] h-[140px] flex items-center justify-center mb-4">
              <img
                src="@/assets/images/home/overview-icon-choose.png"
                alt="icon for free trial"
                class="w-16 h-16"
              />
            </div>
            <p class="text-gray-600 text-center">Choose any program for your FREE trial class</p>
          </div>

          <!-- Icon 2: Coaching -->
          <div class="flex flex-col items-center">
            <div class="rounded-full border border-[#FFE54F] w-[140px] h-[140px] flex items-center justify-center mb-4">
              <img
                src="@/assets/images/home/overview-icon-coaching.png"
                alt="Icon for coaching"
                class="w-16 h-16"
              />
            </div>
            <p class="text-gray-600 text-center">Experience expert coaching</p>
          </div>
          
          <!-- Icon 3: Community -->
          <div class="flex flex-col items-center">
            <div class="rounded-full border border-[#FFE54F] w-[140px] h-[140px] flex items-center justify-center mb-4">
              <img
                src="@/assets/images/home/overview-icon-community.png"
                alt="Icon for community"
                class="w-16 h-16"
              />
            </div>
            <p class="text-gray-600 text-center">Meet our supportive community</p>
          </div>

          <!-- Icon 4: No Pressure -->
          <div class="flex flex-col items-center">
            <div class="rounded-full border border-[#FFE54F] w-[140px] h-[140px] flex items-center justify-center mb-4">
              <img
                src="@/assets/images/home/overview-icon-stars.png"
                alt="Icon for no obligations"
                class="w-16 h-16"
              />
            </div>
            <p class="text-gray-600 text-center">No pressure, no obligations</p>
          </div>
      </div>

      <div class="text-center">
        <ButtonLink 
          text="Start your free trial"
          url="/free-trial"
          color="white"
        />
      </div>
    </div>
  </section>
</template>

<script>
  import ButtonLink from '../Common/ButtonLink.vue'

  export default {
    name: 'ProgramOverview',
    components: {
      ButtonLink
    }
  }
</script>
